import React, { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import DropZone from '../../dropzone'
import { FormSelectYesNo, FormTextArea } from '../formelements'
import config from '../../../config'


export default function EnrolmentFormEmploymentData(props) {

  /* DADES GENERALS */
  const [ errors, setErrors ] = useState({});
  const [ errorValidacioIDdocument, setErrorValidacioIDdocument ] = useState();

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* DADES LABORALS */
  const [dadesLaboralsOpen, setDadesLaboralsOpen] = useState(true);
  const toggleDadesLaboralsOpen = () => {
    setDadesLaboralsOpen(!dadesLaboralsOpen);
  }

  const [dadesLaborals, setDadesLaborals] = useState({validat: false});

  const [treballant, setTreballant] = useState();
  const [treballantFile, setTreballantFile] = useState();
  const [hasTreballatMai, setHasTreballatMai] = useState();
  const [hasTreballatMaiSector, setHasTreballatMaiSector] = useState();
  const [hasTreballatSector, setHasTreballatSector] = useState();
  const [treballarasDurantCurs, setTreballarasDurantCurs] = useState();
  const [treballarasDurantCursHorari, setTreballarasDurantCursHorari] = useState();
  const [creusTreballarDificultaEstudis, setCreusTreballarDificultaEstudis] = useState();


  const handleFileError = (e,msg) => {
    let err  = {...errors}
    err[e] = msg 
    setErrors(err)
  }


  /* VALIDA DADES LABORALS */

   const validaTreballant = () => { return treballant ? null : "Heu de triar un valor" }
   const validaTreballantFile  = () => { if( treballant === "1") { return treballantFile ? null : "Heu d'adjuntar un arxiu" } return null }
   const validaHasTreballatMai = () => { return hasTreballatMai ? null : "Heu de triar un valor" }
   const validaHasTreballatSector = () => { return hasTreballatSector ? null : "Heu de triar un valor" }
   const validaTreballarasDurantCurs = () => { return treballarasDurantCurs ? null : "Heu de triar un valor" }
   const validaTreballarasDurantCursHorari = () => { return treballarasDurantCursHorari ? null : "Heu d'omplir el camp" }
   const validaCreusTreballarDificultaEstudis = () => { return creusTreballarDificultaEstudis ? null : "Heu de triar un valor" }

  const validaLaborals = (e) => {
    e.preventDefault();

    let error = {}

    error.treballant = validaTreballant()
    handleErrors('treballant', error)

    if (config.treballantFile) {
      error.treballantFile = validaTreballantFile()
      handleErrors('treballantFile', error)
    }

    error.hasTreballatMai = validaHasTreballatMai()
    handleErrors('hasTreballatMai', error)

    if (config.hasTreballatSector && hasTreballatMai === "1") {
        error.hasTreballatSector = validaHasTreballatSector()
        handleErrors('hasTreballatSector', error)
    }

    error.treballarasDurantCurs = validaTreballarasDurantCurs()
    handleErrors('treballarasDurantCurs', error)



    if (treballarasDurantCurs === "1") 
    {
      error.treballarasDurantCursHorari = validaTreballarasDurantCursHorari()
      handleErrors('treballarasDurantCursHorari', error)
    }


    error.creusTreballarDificultaEstudis = validaCreusTreballarDificultaEstudis()
    handleErrors('creusTreballarDificultaEstudis', error)


    setErrors(error)

    let noError = true;
    //DEVELOP if (window.location.hostname !== "localhost" ) Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
    if(!config.develop) // bypass errors if develop == true
    {
     Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
    }

    //console.log('ERROR',error);

    handleDadesLaborals(noError)

    if(noError)
    {
        //setDadesIdentificativesOpen(false)
        //setDadesMediquesOpen(false)
        setDadesLaboralsOpen(false)
    }

    return false;
  }

  // exposem la validació real (botó SEGÜENT) perquè l'easter egg de develop
  // (jumpInscripcio a enrolmentform/index.js) pugui disparar-la directament
  useEffect(() => {
    props.exposeValida?.({ valida: validaLaborals })
  })

  const handleDadesLaborals = (noError) => {

  let d = {
   "validat": noError,

  /* DADES LABORALS */
  "treballant": treballant, 
  "treballantFile": treballantFile, 
  "hasTreballatMai": hasTreballatMai, 
  "hasTreballatMaiSector": hasTreballatMaiSector, 
  "hasTreballatSector": hasTreballatSector, 
  "treballarasDurantCurs": treballarasDurantCurs, 
  "treballarasDurantCursHorari": treballarasDurantCursHorari, 
  "creusTreballarDificultaEstudis": creusTreballarDificultaEstudis } 

    //console.log("DADES_LABORALS",d)
    setDadesLaborals(d)
    props.handleDadesLaborals(d)
  }


  return (
    <>
      {/* DADES LABORALS */}
      <div className="container si-display">
        <div className="row">
          <div className="col col-12 ">
            <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
              <div className="t-Region-header">
                <div className="t-Region-headerItems  t-Region-headerItems--controls">
                  <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={toggleDadesLaboralsOpen}>
                    {dadesLaboralsOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                    {!dadesLaboralsOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                  </button>
                </div>
                <div className="t-Region-headerItems t-Region-headerItems--title">
                  <h2 className="t-Region-title a-Collapsible-heading">Dades laborals</h2>
                </div>
                <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
              </div>
              <div className="t-Region-bodyWrap">

                <Dropdown open={dadesLaboralsOpen}>
                  <div className="t-Region-body a-Collapsible-content">

                    <div className="container">
                      <div className="row">
                        <div className="col col-12 ">
                          <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                            <div className="t-Region-bodyWrap">
                              <div className="t-Region-body">
                                <div className="container">
                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="treballant"
                                        name="treballant"
                                        col="col-2"
                                        label="Actualment estàs treballant?"
                                        obligatori={false}
                                        value={treballant}
                                        error={errors.treballant}
                                        handleChange={(e) => setTreballant(e.target.value)} />

                                { config.treballantFile && (<>
                                  { treballant === "1" && 
                                    (<DropZone id="treballantFile" file={treballantFile} onChange={setTreballantFile} 
                                    label="Adjuntar contracte de treball*" 
                                    labelDrop="adjuntar document*" 
                                    error={errors.treballantFile} 
                                    handleFileError={ (msg) =>handleFileError('treballantFile',msg) }  />
                                    ) 
                                  }
                                </>)}
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="treballatMai"
                                        name="treballatMai"
                                        col="col-2"
                                        label="Has treballat mai?"
                                        obligatori={false}
                                        value={hasTreballatMai}
                                        error={errors.hasTreballatMai}
                                        handleChange={(e) => setHasTreballatMai(e.target.value)} />

                                      {hasTreballatMai === "1" && <FormTextArea id="hasTreballatMaiSector" name="hasTreballatMaiSector" col="col-5" label="En quin sector professional?" value={hasTreballatMaiSector} obligatori={false} rows="5" cols="80" maxLength="1000" onChange={setHasTreballatMaiSector} error={errors.hasTreballatMaiSector} />}

                                    </div>
                                  </div>

                                  {(config.hasTreballatSector === true && hasTreballatMai === "1") && (
                                    <div className="row">
                                      <div className="col col-12 ">

                                        <FormSelectYesNo id="hasTreballatSector"
                                          name="hasTreballatSector"
                                          col="col-4"
                                          label="Has treballat/treballes al mateix sector dels estudis als quals vols accedir?"
                                          obligatori={false}
                                          value={hasTreballatSector}
                                          error={errors.hasTreballatSector}
                                          handleChange={(e) => setHasTreballatSector(e.target.value)} />
                                      </div>
                                    </div>
                                  )}

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="treballarasDurantCurs"
                                        name="treballarasDurantCurs"
                                        col="col-2"
                                        label="Treballaràs durant el curs?"
                                        obligatori={false}
                                        value={treballarasDurantCurs}
                                        error={errors.treballarasDurantCurs}
                                        handleChange={(e) => setTreballarasDurantCurs(e.target.value)} />

                                      {treballarasDurantCurs === "1" && <FormTextArea id="treballarasDurantCursHorari" name="treballarasDurantCursHorari" col="col-5" label="De què i en quin horari?*" value={treballarasDurantCursHorari} obligatori={true} rows="5" cols="80" maxLength="1000" onChange={setTreballarasDurantCursHorari} error={errors.treballarasDurantCursHorari} />}

                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="creusTreballarDificultaEstudis"
                                        name="creusTreballarDificultaEstudis"
                                        col="col-2"
                                        label="Creus que treballar et dificultarà els teus estudis?"
                                        obligatori={false}
                                        value={creusTreballarDificultaEstudis}
                                        error={errors.creusTreballarDificultaEstudis}
                                        handleChange={(e) => setCreusTreballarDificultaEstudis(e.target.value)} />

                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col col-12" align="center">
                        <button onClick={validaLaborals} className="button">SEGÜENT</button>
                      </div>
                    </div>
                  </div>

                </Dropdown>
              </div>
            </div>

          </div>
        </div>
      </div>

    </>
  )
}